import { parseDate, sortDates } from "../../../../utilities";

export const inputsRecordTrainedUsers = {
  trainingOrg: {
    key: "trainingOrg",
    label: "Организация,осуществившая обучение",
    options: [],
    type: "selectWithSearch",
    required: true,
    disabled: false,
    searchable: true,
  },
  trainingProgId: {
    key: "trainingProgId",
    label: "Программа подготовки",
    options: [],
    type: "selectWithSearch",
    required: true,
    disabled: false,
    searchable: false,
  },
};

export const columnsRecordTrainedUsersTable = [
  {
    Header: "ФИО",
    accessor: "fio",
    editable: false,
    viewType: "text",
  },
  {
    Header: "Идент.номер ",
    accessor: "persNum",
    editable: false,
    viewType: "text",
  },
  {
    Header: "Дата рождения",
    accessor: "birthDateTable",
    editable: false,
    viewType: "text",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },

  {
    Header: "Период обучения с",
    accessor: "trainingDocumentsDateStartTable",
    editable: false,
    viewType: "text",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Период обучения по",
    accessor: "trainingDocumentsDateEndTable",
    editable: false,
    viewType: "text",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Документ об образовании (вид, серия, номер, дата)",
    accessor: "docAboutEducation",
    editable: false,
    viewType: "text",
  },
  {
    Header: "Адрес",
    accessor: "address",
    editable: false,
    viewType: "text",
  },
  {
    Header: "Телефон",
    accessor: "phone",
    editable: false,
    viewType: "text",
  },
  {
    Header: "",
    accessor: "deleteRow",
    editable: false,
    typeEdit: "text",
    viewType: "button",
    naming: "X",
    style: "delete-button",
  },
];

export const setOptionsInputsRecordTrainedUsers = (type, props) => {
  switch (type) {
    case "firstInit": {
      inputsRecordTrainedUsers.trainingProgId.options = props.trainingPrograms;
      inputsRecordTrainedUsers.trainingOrg.options = props.trainingOrganization;
      inputsRecordTrainedUsers.trainingProgId.disabled = false;
      inputsRecordTrainedUsers.trainingOrg.disabled = false;
      break;
    }
    case "disabled": {
      inputsRecordTrainedUsers.trainingProgId.disabled = props;
      inputsRecordTrainedUsers.trainingOrg.disabled = props;
      break;
    }
  }
};
export const getOptionsInputsRecordTrainedUsers = () => inputsRecordTrainedUsers;
